/**
 * Уникальный ключ сессии чата на этом браузере (localStorage, на договор).
 * В другом браузере — другой ключ → отдельная история на сервере.
 */
const STORAGE_PREFIX = "signingAssistant:clientKey:"

const KEY_RE = /^[a-zA-Z0-9_-]{8,128}$/

export function getOrCreateSigningAssistantClientKey(contractId: string): string {
  const storageKey = `${STORAGE_PREFIX}${contractId}`
  try {
    const existing = localStorage.getItem(storageKey)
    if (existing && KEY_RE.test(existing)) {
      return existing
    }
    const id =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(36).slice(2, 18)}`
    localStorage.setItem(storageKey, id)
    return id
  } catch {
    const tail = `${Date.now()}${Math.random().toString(36).slice(2, 18)}`
    return `fb${tail}`.slice(0, 128)
  }
}
